import { PayoutHistoryTable } from '@/components'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { SellerPaymentMethod } from '@/components/sellerProfileForms'
import React from 'react'
import { fetchSellerPaymentMethodsQueryOptions } from '@/queryOptions/seller/fetchSellerInfo'
import { useQuery } from '@tanstack/react-query'
import { getUserFromLS } from '@/utils/helper/getUserFromLS'

const Payouts = () => {
  const user = getUserFromLS();
   const {data: sellerPaymentMethods , isLoading} = useQuery(fetchSellerPaymentMethodsQueryOptions({ seller_id: {eq: user?.user_id }}))

  return (
    <div className="min-h-screen bg-gray-50 p-6">
    <div className="w-full mx-auto">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Payouts</h1>
        <p className="text-gray-600">Manage how and when you get paid</p>
      </div>

      {/* Main Content Grid */}
      <div className={`grid grid-cols-1 lg:grid-cols-${user?.user_id && sellerPaymentMethods?.[0] ? "2" : "1"} gap-6`}>
        {/* Available Balance Card */}
        <Card className="bg-white border border-gray-200 shadow-sm">
          <CardHeader className="pb-4">
            <CardTitle className="text-xl font-semibold text-gray-900">Available Balance</CardTitle>
            <CardDescription className="text-gray-500">Ready to withdraw</CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div>
              <div className="text-4xl font-bold text-gray-900 mb-2">$3,245.89</div>
              <p className="text-sm text-gray-500">Next automatic payout: May 25, 2025</p>
            </div>
            <Button className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-md font-medium" size="default">
              Withdraw Now
            </Button>
          </CardContent>
        </Card>

        {/* Payment Method Card */}
        {
          user?.user_id && sellerPaymentMethods?.[0] && (
            <SellerPaymentMethod paymentMethods={sellerPaymentMethods?.[0]} sellerId={user?.user_id} loading={isLoading} />
          )
        }
      </div>
    <PayoutHistoryTable  />
    </div>
  </div>
  )
}

export default Payouts
